import React from "react";
import * as Sentry from "@sentry/react";
import { Provider } from "react-redux";
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from "react-dom";
import "./index.css";
import { PublicClientApplication } from "@azure/msal-browser";
import "./translations/i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { msalConfig } from "./config/MsAuthConfig";
import store from "./redux/store";
import "moment/locale/es";

const msalInstance = new PublicClientApplication(msalConfig);
export { msalInstance as default };

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    new Sentry.BrowserTracing({
      tracePropagationTargets: ["localhost", /burnout-zero\.com$/],
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: process.env.REACT_APP_SENTRY_SAMPLE_RATE, // Capture 100% of the transactions, reduce in production!
  // Session Replay
});

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App pca={msalInstance} />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
